import React from 'react'
import { Helmet } from 'react-helmet-async'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import Heroimg2 from '../components/Heroimg2'
import Paymentsystem from '../components/Paymentsystem'



const Pay = () => {
  return (
    <>
    <Helmet>
      <title>Payment</title>
      <meta name='description' content={"'Payment access here'"}/>
      <link rel='canonical' href='' />
    </Helmet>
    
    <Navbar/>
    <Heroimg2 heading="PAYMENT." text="Credit card access"/>
    <Paymentsystem/>
    <Footer/>

    </>
  )
}

export default Pay
